<style lang="scss">
@import '../assets/sass/abstracts/_variables.scss';
div.watercourse-table {
  font-size: 14px;
  margin-top: 20px;

  .positive {
    color: green;
  }
  .negative {
    color: red;
  }

  .fi-check {
    color: $nina-darkgray;
  }

  sup {
    font-weight: bolder;
    color: black;
    font-size: 80% !important;
  }

}


@media screen and (max-width: 39.9375em) {
  div.watercourse-table {
    font-size: 12px;
    th,
    td {
      padding: 4px;
    }
  }
}
</style>
<template>
  <div class="watercourse-table">
    <table>
      <thead>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="År prøven er tatt">År</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="År for historisk referanseprøve i samme vassdrag">ÅrRef</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="Prøven består av voksen laks (V) eller ungfisk (U)">V/U</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="Prøvestørrelse for utvalget">Utv.</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="Innkryssing beregnet mot historisk referanse fra samme vassdrag">Innkr.ref</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="Innkryssing beregnet mot historisk referanse fra samme innvandringsgruppe ">Innkr.all</div></th>
        <th><div class="has-tip" data-tooltip aria-haspopup="true" data-disable-hover="false" tabindex="1" title="5-persentilen for prøven, dvs. 5 prosent av individene i prøven har lavere eller lik P(Vill)">5pers</div></th>
      </thead>
      <tbody>
        <tr v-for="result in watercourseResults" v-bind:key="result.id">
          <td><span v-if="result.hiSample"><strong><em>HI</em></strong></span> {{result.year}} </td>
          <td>{{result.yearRef}}</td>
          <td>
            <span v-if="result.adult == '1'">V</span>
            <span v-if="result.adult == '0'">U</span>
            <span v-if="result.adult == '0,1'">
              <span>V</span>
              <span>U</span>
            </span>
          </td>
          <td>{{result.sampleSize}}</td>
          <td>{{result.innkryssingRef}} <sup>{{ result.innkrRefSign}}</sup> </td>
          <td>{{result.innkryssingAll}} <sup class="science-style">{{ result.innkrAlleSign}}</sup></td>
          <td>{{result.femPers}} <sup class="science-style">{{ result.femPersSign }}</sup></td>
          <!-- <td><span v-if="result.hiSample"><i class="fi-check"></i></span></td> -->
        </tr>
      </tbody>
    </table>
    <p>Signifikanssannsynlighetene er gitt slik: <strong>ns</strong> for p > 0,1; <strong>.</strong> for 0,1>p>0,05, <strong>*</strong> for p< 0,05, <strong>**</strong> 
      for p < 0,01, og <strong>***</strong> for p < 0,001. <strong>NA</strong> = ikke analysert</p>
    <p v-show="hasHISamples"><span><strong><em>HI</em></strong></span>: Beregninger gjort av Havforskningsinstituttet (Glover mfl. 2013)</p>
  </div>
 
  
</template>

<script>
export default {
  created() {
    this.$store.dispatch('loadWatercourse', { id: this.$route.params.id });
  },
  computed: {
    watercourse() {
      return this.$store.getters.getWatercourse;
    },
    hasHISamples() {
       return this.watercourseResults.some(w => w.hiSample);
    },
    watercourseResults() {
      if (this.$store.getters.getWatercourse.watercourseResults !== undefined) {
        var result = this.$store.getters.getWatercourse.watercourseResults;
        
        return result;
      }
      return null;
    }
  
  }
};
</script>
